import { DetailsList, PanelType, SelectionMode, Stack } from '@fluentui/react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataLotCommercial } from '../../data/DataLotCommercial.jsx';
import { Immocom } from '../../specifique/immocom';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheLotCommercial extends Component {

    static defaultProps = {
        idLot: undefined,
        idLotCommercial: undefined,
        idOperation: undefined,
        isOpen: false,
        onDismiss: () => null,
    }

    static defaultState = {
        lotCommercial: {},
        lotPrincipal: {},
        listLotSecondaire: [],
        listTvaTaux: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheLotCommercial.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement du lot commercial"
        });

        const { idOperation, idLotCommercial, idLot } = this.props;

        DataLotCommercial._chargementInformationLotEspaceDeVente(idOperation, idLotCommercial, idLot).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const { lotCommercial, lotPrincipal, listLotSecondaire, listTvaTaux } = objetData;
                const state = { lotCommercial, lotPrincipal, listLotSecondaire, listTvaTaux };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, { ...FicheLotCommercial.defaultState }, retourVerif, responseFetch);
        });

    };

    _getColumnsDetailsListLotSecondaire = () => {
        return [
            { fieldName: "numero", key: "numero", maxWidth: 100, minWidth: 50, name: "N° lot" },
            { fieldName: "lotType", key: "lotType", maxWidth: 80, minWidth: 50, name: "Type" },
            { fieldName: "etage", key: "etage", maxWidth: 35, minWidth: 35, name: "Etage" },
            { fieldName: "batiment", key: "batiment", maxWidth: 30, minWidth: 30, name: "Bât." },
            { fieldName: "exposition", key: "exposition", maxWidth: 30, minWidth: 30, name: "Expo", },
            {
                key: "surfaceHabitable", maxWidth: 50, minWidth: 50, name: "SHA",
                onRender: (item) => {
                    const sha = item.surfaceHabitable != null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.surfaceHabitable).toFixed(2), false, 2) + "m²" : null;
                    return <span>{sha}</span>;
                }
            },
            {
                key: "prixHT", maxWidth: 100, minWidth: 50, name: "Prix HT",
                onRender: (item) => {
                    let prixHT = item.prixHTLot || item.prixHT;
                    prixHT = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(prixHT || 0).toFixed(2), false, 2);
                    return <span>{prixHT} €</span>;
                }
            },
            {
                key: "loyerAnnuelHT", maxWidth: 100, minWidth: 50, name: "Loyer HT",
                onRender: (item) => {
                    const loyerAnnuelHT = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.loyerAnnuelHT || 0).toFixed(2), false, 2);
                    return <span>{loyerAnnuelHT} €</span>;
                }
            },
            {
                key: "prixMobilierHT", maxWidth: 100, minWidth: 50, name: "Prix mobilier",
                onRender: (item) => {
                    const prixMobilierHT = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixMobilierHT || 0).toFixed(2), false, 2);
                    return <span>{prixMobilierHT} €</span>;
                }
            },
            { fieldName: "numCoPro", key: "numCoPro", maxWidth: 50, minWidth: 50, name: "N° CoPro", }
        ];
    };

    _getColumnsDetailsListTva = () => {
        return [
            {
                key: "ordre", maxWidth: 100, minWidth: 50, name: "",
                onRender: (item) => {
                    let ordre = "Choix principal";
                    if (item.ordre > 1)
                        ordre = `${item.ordre}ème choix`;
                    return <span>{ordre}</span>;
                }
            },
            { fieldName: "tvaCas", key: "tvaCas", name: "TVA" },
            {
                key: "prixTTC", maxWidth: 100, minWidth: 100, name: "Prix TTC",
                onRender: (item) => {
                    const { prixHT } = this.state.lotCommercial;
                    const prixTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(prixHT * (1 + item.taux)).toFixed(2), false, 2);
                    return <span>{prixTTC} €</span>;
                }
            },
            {
                key: "prixHT", maxWidth: 100, minWidth: 100, name: "Prix HT",
                onRender: (item) => {
                    const prixHT = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(this.state.lotCommercial.prixHT).toFixed(2), false, 2);
                    return <span>{prixHT} €</span>;
                }
            },
        ];
    };

    _onDismiss = () => {
        this.setState({ ...FicheLotCommercial.defaultState });
        this.props.onDismiss();
    };

    componentDidUpdate = (prevProps) => {
        const { idOperation, idLotCommercial, idLot } = this.props;
        if (!!idOperation && !!idLotCommercial && !!idLot)
            if (idOperation !== prevProps.idOperation || idLotCommercial !== prevProps.idLotCommercial || idLot !== prevProps.idLot)
                this._chargementDonnees();
    };

    render = () => {

        const { lotPrincipal, listLotSecondaire, listTvaTaux } = this.state;
        const listlotPrincipalEtLotSecondaire = [...listLotSecondaire];
        listlotPrincipalEtLotSecondaire.sort((a, b) => a.rangAffichage - b.rangAffichage);
        listlotPrincipalEtLotSecondaire.unshift(lotPrincipal);

        const styles = {
            sousTitre: {
                borderBottom: "2px solid #fd0400",
                fontSize: "18px",
                fontWeight: "600",
                padding: "10px",
            },
        };

        return <EUIPanel
            headerText={`Détail du lot N°${lotPrincipal.numero}`}
            isOpen={this.props.isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            type={PanelType.largeFixed}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack tokens={{ childrenGap: 20 }}>

                <Stack.Item>
                    <div style={styles.sousTitre}>Informations sur le lot commercial</div>
                    <DetailsList
                        items={listTvaTaux.sort((a, b) => a.ordre - b.ordre)}
                        items={listTvaTaux}
                        columns={this._getColumnsDetailsListTva()}
                        selectionMode={SelectionMode.none}
                    />
                </Stack.Item>

                <Stack.Item>
                    <div style={styles.sousTitre}>Lots associés</div>
                    <DetailsList
                        items={listlotPrincipalEtLotSecondaire}
                        columns={this._getColumnsDetailsListLotSecondaire()}
                        selectionMode={SelectionMode.none}
                    />
                </Stack.Item>

            </Stack>

        </EUIPanel>;

    };

};